var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FieldBox from '../../../../uikit/fields/FieldBox';
import ExplainedChoice from '../../../../uikit/special/ExplainedChoice';
import { withFormikField } from '../../../../hoc/withFormikField';
import { getTranslation } from '../../../../utils/translations';
import { translations } from './translations';
import { PREFERRED_CHANNELS } from '../../../../pages/MainFormPage/formPages/AdvicePage/formModel.types';
import { OfficeBuildingMarkerIcon } from '../../../atoms/SvgIcons/OfficeBuildingMarkerIcon';
import { MonitorStarIcon } from '../../../atoms/SvgIcons/MonitorStarIcon';
import { CellphoneIcon } from '../../../atoms/SvgIcons/CellphoneIcon';
var t = getTranslation(translations);
var btnDescription = {
    btnTitle: t.btnTitle,
    activeBtnTitle: t.activeBtnTitle,
};
var predefinedOptions = [
    __assign({ label: t.phone_label, value: PREFERRED_CHANNELS.PHONE, list: [t.phone_list_1, t.phone_list_2], Icon: CellphoneIcon }, btnDescription),
    __assign({ label: t.video_label, value: PREFERRED_CHANNELS.VIDEO, list: [t.video_list_1, t.video_list_2, t.video_list_3, t.video_list_4], Icon: MonitorStarIcon }, btnDescription),
    __assign({ label: t.offline_label, value: PREFERRED_CHANNELS.OFFLINE, list: [t.offline_list_1, t.offline_list_2, t.offline_list_3], Icon: OfficeBuildingMarkerIcon }, btnDescription),
];
export var PreferredChannelField = function (_a) {
    var errors = _a.errors, restProps = __rest(_a, ["errors"]);
    var error = errors && errors.length ? errors[0] : undefined;
    return (React.createElement(FieldBox, __assign({}, restProps, { error: error }),
        React.createElement(ExplainedChoice, __assign({}, restProps, { options: predefinedOptions }))));
};
export var PreferredChannelFormikField = withFormikField(PreferredChannelField);
